export enum AttendanceSituation {
    Resolved = 'Resolved',
    NotResolved = 'NotResolved',
    Cancelled = 'Cancelled',
}

export const AttendanceSituationLabels = {
    [AttendanceSituation.Resolved]: 'Resolvido',
    [AttendanceSituation.NotResolved]: 'Não resolvido',
    [AttendanceSituation.Cancelled]: 'Cancelado',
}
export const AttendanceSituationOptions = Object.values(AttendanceSituation).map(value => ({value, label: AttendanceSituationLabels[value]}));
